import React from "react";
import AboutBackground from "../Assets/about-background.png";
import AboutBackgroundImage from "../Assets/about-background-image.png";
import DownloadAppStore from "../Assets/download-app-store.png";
import GetItOn from "../Assets/get-it-on.png";
import { APP_STORE_URL, PLAY_STORE_URL } from "../storeLinks";

const About = () => {
  return (
    <div className="about-section-container">
      <div className="about-background-image-container">
        <img src={AboutBackground} alt="" />
      </div>
      <div className="about-section-image-container">
        <img src={AboutBackgroundImage} alt="" />
      </div>
      <div className="about-section-text-container">
        {/* <p className="primary-subheading">About</p> */}
        <h1 className="primary-heading">
        Keep track of your money
        </h1>

        <p className="primary-text">
        Designed to help you track expenses, create personalized budgets, and manage your income effortlessly.        </p>
        <div className="about-buttons-container">
          <a 
            href={APP_STORE_URL} 
            className="store-button"
            rel="noopener noreferrer"
          >
            <img src={DownloadAppStore} alt="Download on the App Store" />
          </a>
          <a 
            href={PLAY_STORE_URL} 
            className="store-button"
            rel="noopener noreferrer"
          >
            <img src={GetItOn} alt="Get it on Google Play" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;
